import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { addcontext } from '../../ContextShare/ContextShare';
import TableArchives from './TableArchives';
import GridArchives from './GridArchives';
import Logo_path from '../../Components/Logo_path';
import { FilterArchivesData, GetAllMemberIdArray, GetAllMemberIdArrayWithSession, GetArchlistUser, GetConstituencyListForSearchFilter, GetEventListForSearchFilter, GetKlaListForSearchFilter, GetMemberListForSearchFilter, GetMemberListForSearchFilterWithSession, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla } from '../../Services/allApi';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon } from '@iconify/react';
import language from '../../language.json'
import usePersistedState from '../../hooks/usePersistedState'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function Archives() {
    const {
        archivesPaginationTotal,
        setarchivesPaginationTotal,
        archivesPaginationEnd,
        setarchivesPaginationEnd,
        archivesPaginationStart,
        setarchivesPaginationStart
    } = useContext(addcontext);
    const { paginationStartIndex, setPaginationStartIndex } = useContext(addcontext)
    const { paginationEndIndex, setPaginationEndIndex } = useContext(addcontext)
    const [errorMessage, setErrorMessage] = useState()
    const [isGridView, setIsGridView] = useState(false);
    const [getARCListData, setGetARCListData] = useState([]);
    const [selectedOptionKla, setSelectedOptionKla] = usePersistedState('filters.archives.selectedOptionKla', null);
    const [selectedOptionsession, setSelectedOptionsession] = usePersistedState('filters.archives.selectedOptionsession', null);
    const [selectedOptionMember, setSelectedOptionMember] = usePersistedState('filters.archives.selectedOptionMember', null);
    const [selectedOptionconstituency, setSelectedOptionconstituency] = usePersistedState('filters.archives.selectedOptionconstituency', null);
    const [selectedOptionEvent, setSelectedOptionEvent] = usePersistedState('filters.archives.selectedOptionEvent', null);
    const [klaList, setKlaList] = useState([]);
    const [sessionList, setSessionList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [constituencyList, setConstituencyList] = useState([]);
    const [startDate, setStartDate] = usePersistedState('filters.archives.startDate', null);
    const [endDate, setEndDate] = usePersistedState('filters.archives.endDate', null);
    const [videoCount, setVideoCount] = useState()
    const { langChanged, setlangChanged } = useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
    const [isFiltered, setisFiltered] = usePersistedState('filters.archives.isFiltered', false)
    
    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en')

    }, [currentLanguage, langChanged])
     
    // fetching starts for filter logic-----------------------------------------------------------------
    // Fetch KLA List
    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaList(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApi();
    }, []);

    const klaoptions = klaList.map((item) => ({
        value: item.kla_id,
        label: `${language.kla[currentLanguage]}${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApi = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionList(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApi();
    }, [selectedOptionKla]);

    const sessionoptions = sessionList.map((item) => ({
        value: item.session_id,
        label: `${language.Session[currentLanguage]}${item.session_no}`,
    }));

    // Fetch Event List
    const EventListCallApi = async () => {
        try {
            const resultEvent = await GetEventListForSearchFilter();
            setEventList(resultEvent?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Event list for filter:", error);
        }
    };

    useEffect(() => {
        EventListCallApi();
    }, []);

    const eventoptions = eventList.map((item) => ({
        value: item.event_id,
        label: currentLanguage == 'en' ? item.event_name : item?.mal_event_name

    }));

    // Fetch Member List
    const MemberListCallApi = async () => {

        try {

            // const resultMember =selectedOptionsession? await GetMemberListForSearchFilterWithSession({session_id:selectedOptionsession?.value}):await GetMemberListForSearchFilter();
            const resultMember = selectedOptionsession ? await GetAllMemberIdArrayWithSession({ session_id: selectedOptionsession?.value }) : await GetAllMemberIdArray();
            setMemberList(resultMember?.data || []);
        } catch (error) {
            console.error("Error fetching Member list for filter:", error);
        }
    };

    useEffect(() => {
        MemberListCallApi();
    }, [selectedOptionsession]);

    const memberoptions = memberList.map((item) => ({
        value: item.id,
        label: currentLanguage == 'en' ? item.member : item?.malayalam_member_name
    }));

    // Fetch Constituency List
    const ConstituencyListCallApi = async () => {
        try {
            const resultConstituency = await GetConstituencyListForSearchFilter();
            setConstituencyList(resultConstituency?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Constituency list for filter:", error);
        }
    };

    useEffect(() => {
        ConstituencyListCallApi();
    }, []);

    const constituencyoptions = constituencyList.map((item) => ({
        value: item.constituency_id,
        label: currentLanguage == 'en' ? item?.constituency_name : item?.mal_constituency_name,
    }));
    // filter logic-----------------------------------------------------------------

    const handlechange = (option) => {setSelectedOptionKla(option)
        setisFiltered(true)
    };
    const handlechangesession = (option) => {setSelectedOptionsession(option)
        setisFiltered(true)
    };
    const handlechangeEvent = (option) => {setSelectedOptionEvent(option)
        setisFiltered(true)
    };
    const handlechangeMember = (option) => {setSelectedOptionMember(option)
        setisFiltered(true)
    };
    const handlechangeconstituency = (option) => {setSelectedOptionconstituency(option)
        setisFiltered(true)
    };
    const handleStartDate=(StDate)=>{
        setStartDate(StDate)
        setisFiltered(true)
    }
    const handleEndDate=(EnDate)=>{
        setEndDate(EnDate)
        setisFiltered(true)
    }

    const toggleView = () => setIsGridView(!isGridView);

    // api to get archives data
    const archivesData = async () => {
        try {
            // console.log(startIndex);
            const result = await GetArchlistUser(paginationStartIndex, paginationEndIndex);
            setGetARCListData(result?.data?.data || []);
            setVideoCount(result?.data?.count)
            console.log(result);
        } catch (error) {
            console.error("Error fetching governor's address data:", error);
        }
    };

    useEffect(() => {
        if(!isFiltered){
            archivesData();
        }
    }, [paginationStartIndex, paginationEndIndex]);

    // filter table data
    const FilterArchives = async () => {
       
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        const member_id = selectedOptionMember?.value;
        const event_id = selectedOptionEvent?.value;
        const constituency_id = selectedOptionconstituency?.value;
        const start_date = startDate
        const end_date = endDate

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        if (member_id) obj.member_id = member_id;
        if (event_id) obj.event_id = event_id;
        if (constituency_id) obj.constituency_id = constituency_id;
        if (startDate) obj.start_date = start_date
        if (end_date) obj.end_date = end_date

        try {
            const result = await FilterArchivesData(obj,paginationStartIndex,paginationEndIndex);
            setGetARCListData(result?.data?.data || []);
            setVideoCount(result?.data?.count)

            setTimeout(() => {
                setErrorMessage(result?.response?.data?.message || null)
            }, 1000)
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession || selectedOptionEvent || selectedOptionMember || selectedOptionconstituency || startDate || endDate) {
            if(isFiltered){
            FilterArchives()}
        }
    }, [selectedOptionKla, selectedOptionsession, selectedOptionEvent, selectedOptionMember, selectedOptionconstituency, startDate, endDate,paginationStartIndex,paginationEndIndex]);

    // reset filter amd set all state to initial
    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setSelectedOptionMember(null)
        setSelectedOptionEvent(null)
        // setSelectedOptionsubject(null)
        setStartDate('')
        setEndDate('')
        archivesData()
        setErrorMessage()
        setisFiltered(false)

    }

    return (
        <>
            <div className='flex flex-col items-center ' style={{ height: '100%', width: '100%', fontFamily: 'Ropa sans' }}>
                <div className='md:w-11/12 w-full md:mb-2 mb-2'>
                    <div><Logo_path AdminOrHome={'Home'} Directory={'Archives'} /></div>
                </div>
            </div>

            <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>

                <div className='w-10/12 flex flex-col'>
                    <div className='text-center'>
                        <h2 className='text-xl mt-0'>{language.navbar.archives[currentLanguage]}</h2>
                    </div>
                    <div className='flex flex-row justify-between'>
                        <div>
                            <div className={`text-left text-sm ${currentLanguage === 'en' ? 'text-sm ':'text-[9px]'}`}>
                                {getARCListData?.length > 0 ? <h4 className='mt-5'>{language.total_results[currentLanguage]} : {videoCount}</h4>
                                    :
                                    <>
                                        {errorMessage ?
                                            ''
                                            :
                                            <Skeleton width={100} />}
                                    </>
                                }
                            </div>
                            <div className={`text-left text-sm ${currentLanguage === 'en' ? 'text-sm ':'text-[9px]'}`}>
                                {getARCListData?.length > 0 ? <h4 className='mt-3'>{language.showing_results[currentLanguage]}  {paginationStartIndex}-{paginationEndIndex} {language.results[currentLanguage]} </h4>
                                    :
                                    <>
                                        {errorMessage ?
                                            ''
                                            :
                                            <Skeleton width={110} />}
                                    </>
                                }
                            </div>
                        </div>

                        {getARCListData?.length > 0 &&<div className={`${currentLanguage != 'en' &&'text-xs'} `}>

                            {!isGridView ? (
                                <button className='p-2 bg-blue-500 rounded hover:bg-blue-900 mt-5 text-white' onClick={toggleView}>
                                    <i className="fa-regular fa-image me-2"></i>{language.grid_view[currentLanguage]}
                                </button>
                            ) : (
                                <button className='p-2 bg-blue-500 rounded hover:bg-blue-900 mt-5 text-white' onClick={toggleView}>
                                    <i className="fa-solid fa-table me-2"></i>{language.table_view[currentLanguage]}
                                </button>
                            )}
                        </div>}
                    </div>

                    {(getARCListData?.length > 0 || errorMessage) ? <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap mt-5'>
                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>
                            <Select
                                placeholder={language.kla[currentLanguage]}
                                className='w-full min-w-24 h-9 '
                                options={klaoptions}
                                value={selectedOptionKla}
                                onChange={handlechange}
                            />
                        </div>
                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>
                            <Select
                                placeholder={language.Session[currentLanguage]}
                                className='w-full min-w-24 h-9'
                                options={sessionoptions}
                                value={selectedOptionsession}
                                onChange={handlechangesession}
                            />
                        </div>
                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>
                            <Select
                                placeholder={language.Event[currentLanguage]}
                                className='w-full text-blue-400 min-w-52 h-9 '
                                options={eventoptions}
                                value={selectedOptionEvent}
                                onChange={handlechangeEvent}
                            />
                        </div>
                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>
                            <Select
                                placeholder={language.Member[currentLanguage]}
                                className='w-full min-w-40 h-9'
                                options={memberoptions}
                                value={selectedOptionMember}
                                onChange={handlechangeMember}
                            />
                        </div>
                        {/* <div className='flex flex-row text-blue-400'>
                            <Select
                                placeholder='Constituency'
                                className='w-full min-w-32 max-h-40'
                                options={constituencyoptions}
                                value={selectedOptionconstituency}
                                onChange={handlechangeconstituency}
                            />
                        </div> */}
                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                            <div>{language.Start_date[currentLanguage]}</div>
                            <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                    type='date'
                                    value={startDate}
                                    // onChange={(date) => setStartDate(date.target.value)}
                                    onChange={(date)=>handleStartDate(date.target.value)}
                                    placeholderText="Start date"
                                    className='rounded w-full h-9 p-2'
                                />
                            </div>
                        </div>
                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                            <div>{language.End_date[currentLanguage]}</div>
                            <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                    type='date'
                                    value={endDate}
                                    // onChange={(date) => setEndDate(date.target.value)}
                                    onChange={(date)=>handleEndDate(date.target.value)}
                                    placeholderText="End date"
                                    className='rounded w-full h-9 p-2'
                                />
                            </div>
                        </div>

                        {(selectedOptionKla || selectedOptionsession || selectedOptionEvent || selectedOptionMember || selectedOptionconstituency || startDate || endDate) && (

                            <div className='flex flex-col '>
                                <div style={{ visibility: 'hidden' }}>end date</div>

                                <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                    <span>{language.Clear_Filter[currentLanguage]}</span>
                                    <Icon icon="bx:reset" />
                                </button>

                            </div>
                        )}
                    </div>
                        :
                        <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap md:mt-8 md:mb-5'>

                            <div className='md:w-40 w-0'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-0'>
                                <Skeleton height={30} />
                            </div>

                        </div>
                    }


                    <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap mt-5'>
                        <div className={`md:w-12/12 w-full transition-opacity duration-500 ease-in-out mb-5 ${isGridView ? 'opacity-0 max-h-0 overflow-hidden' : 'opacity-100 max-h-full'}`}>
                            <TableArchives getARCListData={getARCListData} erm={errorMessage ?? null} count={videoCount} handleResetFilter={handleResetFilter} />
                        </div>
                        <div className={`md:w-12/12 w-full transition-opacity duration-500 ease-in-out ${isGridView ? 'opacity-100 max-h-full' : 'opacity-0 max-h-0 overflow-hidden'}`}>
                            <GridArchives getARCListData={getARCListData} /> 
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Archives;
